import { Component, computed, inject } from '@angular/core';
import { SearchService } from '../../../../services/bidder-community/search/search.service';
import { ActivatedRoute } from '@angular/router';
import { faImage, faList } from '@fortawesome/free-solid-svg-icons';
import { SearchCombinedComponent } from '../search-combined/search-combined.component';
import { ItemsOnlyComponent } from '../items-only/items-only.component';
import { NoResultComponent } from '../no-result/no-result.component';
import { ProgressSpinner } from 'primeng/progressspinner';
import { distinctUntilChanged, skip, Subscription, tap } from 'rxjs';
import { AuthService } from '../../../../services/authentication/auth.service';
import { IAuctionListing } from '../../../../models/IAuctionListing';

@Component({
  selector: 'app-search-main',
  imports: [SearchCombinedComponent,
    ItemsOnlyComponent,
    NoResultComponent,
    ProgressSpinner
  ],
  templateUrl: './search-main.component.html',
  styleUrl: './search-main.component.scss'
})
export class SearchMainComponent {

  query!: string;
  private readonly searchService = inject(SearchService);
  private readonly authService = inject(AuthService);
  authSubscription!: Subscription;


  protected icons = {
    faImage: faImage,
    faList: faList
  }
  viewMode: 'image' | 'list' = 'list';
  ItemListOptions: any[] = [{ label: 'Image View', value: 'image' }, { label: 'List View', value: 'list' }];

  searchResult = this.searchService.searchCombinedSignal;

  isLoading = this.searchService.isLoading;

  auctions = computed(() => this.searchResult()?.auctions ?? []);
  auctionsCount = computed(() => this.searchResult()?.auctionsCount ?? 0);

  items = computed(() => this.searchResult()?.items ?? []);
  itemsCount = computed(() => this.searchResult()?.itemsCount ?? 0);

  constructor(private route: ActivatedRoute) {
  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      const q = params['q'] ?? '';
      if (q) {
        this.query = q;
        this.fetchSearchResults();
      }
    });



    this.authSubscription = this.authService.isAuthenticated$
      .pipe(
        distinctUntilChanged(),
        skip(1),
        tap(isAuth => {
          if (isAuth) {
            this.fetchSearchResults();
          } else {
            this.fetchSearchResults();
          }
        })
      ).subscribe();
  }
  fetchSearchResults() {
    this.searchService.getSearchResult(this.query).subscribe();
  }

  onFavoriteChanged(event: { isFavorite: boolean, itemId: number }) {
    this.searchResult.update(prev => {
      if (!prev) return prev;
      return {
        ...prev,
        items: prev.items.map(item =>
          item.id === event.itemId
            ? { ...item, isFavorite: !event.isFavorite }
            : item
        )
      }
    })
  }


  onMyAuctionsChanged(myAuction: IAuctionListing | null): void {
    this.searchResult.update(prev => {
      if (!prev) return prev;

      return {
        ...prev,
        auctions: prev.auctions.map(auction =>
          auction.auctionId === myAuction?.auctionId
            ? { ...auction, isFavorite: !myAuction.isFavorite }
            : auction
        )
      };
    });
  }



}
